import React, { useRef } from 'react';
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide, SwiperProps } from 'swiper/react';
import classNames from 'classnames';

import { t } from '@web-solutions/module-localization';

import Button from '../button';

import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';

import './style.scss';
import classes from './style.module.scss';

SwiperCore.use([Pagination, Autoplay]);

interface Props {
  slides: React.ReactNode[];
  className?: string;
  onClick?: () => void;
  onClickButton?: () => void;
  isButton?: boolean;
  onSwipe?: (x: number) => void;
  children?: React.ReactNode
}

const SwiperSlider: React.FC<Props & SwiperProps> = ({
  slides,
  className,
  onClick,
  onClickButton,
  isButton = false,
  onSwipe,
  children,
  ...other
}) => {

  const wrapStyle = classNames([
    classes.wrap,
    className,
    { 'wrap-with-button': isButton },
  ]);
  const swiperRef = useRef<SwiperRef>(null);

  const handleBtnClick = () => {
    const swiper = swiperRef.current?.swiper;

    const isLastSlide = swiper?.isEnd;

    if (isLastSlide && onClickButton) {
      onClickButton();
    } else {
      swiper?.slideNext();
    }
  };

  const renderSlides = () =>
    slides.map((slide, i) => (
      <SwiperSlide key={`slide-${i}`} onClick={onClick}>
        {slide}
      </SwiperSlide>
    ));

  const handleSwipe = () => {
    const swiper = swiperRef.current?.swiper;

    if (swiper && onSwipe) {
      onSwipe(swiper?.activeIndex);
    }
  }

  return (
    <div className={wrapStyle}>
      <Swiper
        centeredSlides
        ref={swiperRef}
        pagination
        onActiveIndexChange={handleSwipe}
        {...other}
      >
        {children}
        {renderSlides()}
      </Swiper>
      {isButton && (
        <Button
          flare
          title={t('_continue')}
          onClick={handleBtnClick}
          iconRight={false}
          className={classes.button}
        />
      )}
    </div>
  );
};

export default SwiperSlider;
